import React from 'react';

import ProgressBar from 'app/shared/components/common/ProgressBar';
import PropTypes from 'prop-types';

import useLoading from 'hooks/useLoading';

const withLoading = WrappedComponent => {
  const EnhancedComponent = props => {
    const [isLoading, setIsLoading] = useLoading(false);

    return (
      <>
        {isLoading ? <ProgressBar /> : null}
        <WrappedComponent isLoading={isLoading} setIsLoading={setIsLoading} {...props} />
      </>
    );
  };

  EnhancedComponent.displayName = `withLoading${
    WrappedComponent.displayName || WrappedComponent.name
  }`;

  return EnhancedComponent;
};

export default withLoading;

export const WithLoadingPropTypes = {
  isLoading: PropTypes.bool,
  setIsLoading: PropTypes.func,
};
